import { render, staticRenderFns } from "./ChooseOrderType.vue?vue&type=template&id=fe136140"
import script from "./ChooseOrderType.vue?vue&type=script&lang=js"
export * from "./ChooseOrderType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports